import React from "react";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as HiIcons from 'react-icons/hi'
import * as MdIcons from "react-icons/md";
import * as BiIcons from "react-icons/bi";
import * as FaIcons from "react-icons/fa";
import * as FiIcons from "react-icons/fi";
import * as GiIcons from "react-icons/gi";
import * as ImIcons from "react-icons/im";
import * as TbIcons from "react-icons/tb";
import * as BsIcons from "react-icons/bs";

// import PackageIcon from './Package.png'


function STCIcons(props){

    return(
        <>
            {props.children}

        </>
    )
}
export default STCIcons;

STCIcons.Home = AiIcons.AiFillHome
STCIcons.Bookings = AiIcons.AiFillCalendar
STCIcons.Schools = IoIcons.IoMdPeople
STCIcons.Quotes = IoIcons.IoIosPricetag
STCIcons.Reports = HiIcons.HiDocument
STCIcons.Accounts = MdIcons.MdAccountBalance
STCIcons.Suppliers = BiIcons.BiArchive
STCIcons.Management = MdIcons.MdManageAccounts
STCIcons.Support = BiIcons.BiSupport

STCIcons.Edit = AiIcons.AiFillEdit



STCIcons.CostType1 = MdIcons.MdFlight;                  //Flights
// STCIcons.CostType1 = <img src={'https://cdn-icons-png.flaticon.com/512/6221/6221857.png'} style={{width: 20, height: 20}} />;                  //Flights
STCIcons.CostType2 = MdIcons.MdDirectionsBus;           //Coach
STCIcons.CostType3 = MdIcons.MdHotel;                   //Accommodation
STCIcons.CostType4 = MdIcons.MdCastle;                  //Tour
// STCIcons.CostType4 = <img src={'https://cdn-icons-png.flaticon.com/512/9644/9644014.png'} style={{width: 20, height: 20, padding: 1}} /> ;                  //Tour
STCIcons.CostType5 = TbIcons.TbDotsCircleHorizontal;    //Misc
STCIcons.CostType6 =  ImIcons.ImCross;                  //EBB
STCIcons.CostType7 = GiIcons.GiMeal;                    //Meals
STCIcons.CostType8 = TbIcons.TbDotsCircleHorizontal;    //Other
STCIcons.CostType9 = ImIcons.ImCross;                   //Insurance
STCIcons.CostType10 = FiIcons.FiUserCheck;              //Check In
STCIcons.CostType11 = FaIcons.FaSuitcaseRolling;        //Bags
STCIcons.CostType12 = MdIcons.MdCastle;                 //Entrance
STCIcons.CostType13 = ImIcons.ImCross;                  //Guide
STCIcons.CostType14 = BsIcons.BsBinocularsFill;                //Activity
STCIcons.CostType15 = ImIcons.ImCross;                  //Supplement
STCIcons.CostType16 = ImIcons.ImCross;                  //FlightTBB
STCIcons.CostType17 = ImIcons.ImCross;                  //Ferry
STCIcons.CostType18 = ImIcons.ImCross;                  //FreePlaces
STCIcons.CostType19 = ImIcons.ImCross;                  //Package




STCIcons.CostType1Image = MdIcons.MdFlight;                                                                 //Flights
STCIcons.CostType2Image = MdIcons.MdDirectionsBus;                                                          //Coach
STCIcons.CostType3Image = MdIcons.MdHotel;                                                                  //Accommodation
STCIcons.CostType4ImageColour = 'https://cdn-icons-png.flaticon.com/512/9644/9644014.png';                  //Tour
STCIcons.CostType5Image = 'https://cdn-icons-png.flaticon.com/512/7695/7695811.png';                        //Misc
STCIcons.CostType6Image = TbIcons.TbDotsCircleHorizontal;                                                   //EBB
STCIcons.CostType7ImageColour = 'https://cdn-icons-png.flaticon.com/512/272/272186.png';                    //Meals
STCIcons.CostType8ImageColour = 'https://cdn-icons-png.flaticon.com/512/7695/7695811.png';                  //Other
STCIcons.CostType9Image = TbIcons.TbDotsCircleHorizontal;                                                   //Insurance
STCIcons.CostType10Image = FiIcons.FiUserCheck;                                                             //Check In
STCIcons.CostType11Image = FaIcons.FaSuitcaseRolling;                                                       //Bags
STCIcons.CostType12Image = MdIcons.MdCastle;                                                                //Entrance
STCIcons.CostType13Image = 'https://cdn-icons-png.flaticon.com/512/9636/9636012.png';                       //Guide
STCIcons.CostType13ImageColour = 'https://cdn-icons-png.flaticon.com/512/9644/9644014.png';                 //Guide
STCIcons.CostType14ImageColour = 'https://cdn-icons-png.flaticon.com/512/1527/1527248.png';                 //Activity
STCIcons.CostType15Image = ImIcons.ImCross;                                                                 //Supplement
STCIcons.CostType16Image = ImIcons.ImCross;                                                                 //FlightTBB
STCIcons.CostType17Image = ImIcons.ImCross;                                                                 //Ferry
STCIcons.CostType18Image = ImIcons.ImCross;                                                                 //FreePlaces
// STCIcons.CostType19Image = PackageIcon;                                                                     //Package